<template>
  <div class="row" style="margin-bottom: 2rem !important">
    <div v-if="src" class="image-wrapper">
      <img class="image" :src="src" />
    </div>
    <div class="row align-items-end">
      <div>
        <div class="row" style="font-size: 3rem; font-weight: bold">
          {{ basicInfo.user_name }}
        </div>
        <div class="row resume-view-details" v-if="basicInfo.email">{{ basicInfo.email }}</div>
        <div class="row resume-view-details" v-if="basicInfo.phone">{{ basicInfo.phone }}</div>
        <div class="row resume-view-details" v-if="basicInfo.company_name">{{ basicInfo.company_name }}</div>
        <div class="row resume-view-details" v-if="basicInfo.institution_name">
          {{ basicInfo.institution_name }}
        </div>

        <div class="row resume-view-details" v-if="basicInfo.location_name">{{ basicInfo.location_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMAGE } from "../../../Api/common_api";
import Store from "../../../store/store";
import basicInfoVue from "../../candidate/information/Basic-Information/basic-info.vue";
import { getOwnerInfo } from "../../../globalConstants";
export default {
  name: "basic-info-view",
  data: function () {
    return {
      displayLocation: "",
      user: {},
      src: "",
    };
  },
  props: {
    basicInfo: Object,
  },
  computed: {
    username() {
      return Store.getters.getName;
    },
  },
  mounted: function () {
    if (this.basicInfo) {
      this.user = this.basicInfo;
      if (this.basicInfo.location_name) {
        this.displayLocation = this.basicInfo.location_name;
      }
      if (this.basicInfo.image_url) {
        this.src = this.basicInfo.image_url;
      }
    }
  },
};
</script>

<style scoped>
.image-wrapper {
  max-height: 22.5rem;
  max-width: 22.5rem;
  margin-right: 2rem;
  overflow: hidden;
  border-radius: 0.4rem;
}
.image {
  width: calc(100% - 0.2rem);
  height: calc(100% - 0.2rem);
}
</style>
